/** KPI card keys → row filter (client-side on daily roster). */
export const ATTENDANCE_KPI_FILTER_KEYS = [
  "total_users",
  "on_time",
  "late",
  "absent",
  "holiday",
  "weekend",
];

export const ATTENDANCE_KPI_LABELS = {
  total_users: "All employees",
  on_time: "On time",
  late: "Late",
  absent: "Absent",
  holiday: "Holiday",
  weekend: "Weekend",
};

export function matchesAttendanceKpiFilter(record, filterKey) {
  if (!filterKey || filterKey === "total_users") return true;
  const status = (record?.attendance_status || "").toLowerCase().trim();
  switch (filterKey) {
    case "on_time":
      return status === "on time" || status === "present";
    case "late":
      return status === "late arrival" || status.includes("late");
    case "absent":
      return status === "absent";
    case "holiday":
      return status === "holiday";
    case "weekend":
      return status === "weekend";
    default:
      return true;
  }
}
